import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { Input } from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';
import { UsersStore } from './UsersStore';

export interface IUserRolesCardProps {
    readonly user: Mri.Web.Portal.Controllers.Account.UserModel;
}

@autoinject
@observer
export class UserRolesCard extends React.Component<IUserRolesCardProps> {
    public render() {
        return (
            <div className="card h-100">
                <div className="card-header bg-btn-primary">Roles</div>

                <div className="card-body px-5">
                    {this.accountStore.isInRole('MriAdmin') && (
                        <div>
                            <Input type="checkbox" checked={this.isMriAdmin} onChange={this.onMriAdminChange} />
                            <span>MRI Administrator</span>
                        </div>
                    )}

                    {this.accountStore.isInRole('MriAdmin') && (
                        <div>
                            <Input type="checkbox" checked={this.isMriUser} onChange={this.onMriUserChange} />
                            <span>MRI User</span>
                        </div>
                    )}

                    {this.accountStore.isInRole('MriAdmin') && (
                        <div>
                            <Input type="checkbox" checked={this.isProdTestUser} onChange={this.onProdTestUserChange} />
                            <span>Prod Test User</span>
                        </div>
                    )}

                    {this.accountStore.isInRole('MriAdmin') && (
                        <div>
                            <Input type="checkbox" checked={this.isProdUser} onChange={this.onProdUserChange} />
                            <span>Prod User</span>
                        </div>
                    )}

                    {this.accountStore.isInRole('MriAdmin') && (
                        <div>
                            <Input type="checkbox" checked={this.isPortalUser} onChange={this.onPortalUserChange} />
                            <span>Portal User</span>
                        </div>
                    )}

                    {this.accountStore.isInRole('MriAdmin') && (
                        <div>
                            <Input
                                type="checkbox"
                                checked={this.isPortalLiteUser}
                                onChange={this.onPortalLiteUserChange}
                            />
                            <span>Portal Lite User</span>
                        </div>
                    )}

                    <Input type="checkbox" checked={this.isPortalAdmin} onChange={this.onAdministratorChange} />
                    <span>Portal Administrator</span>

                    {this.accountStore.isInRole('MriAdmin') && (
                        <div>
                            <Input
                                type="checkbox"
                                checked={this.isCustomerServiceAdminUser}
                                onChange={this.onCustomerServiceAdminUserChange}
                            />
                            <span>Customer Service Admin</span>
                        </div>
                    )}

                    {(this.accountStore.isInRole('MriAdmin') ||
                        this.accountStore.isInRole('MriCustomerServiceAdmin')) && (
                        <div>
                            <Input
                                type="checkbox"
                                checked={this.isCustomerServiceRepUser}
                                onChange={this.onCustomerServiceRepUserChange}
                            />
                            <span>Customer Service Rep</span>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    @bind
    private async onAdministratorChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        if (!this.props.user) return;

        if (target.checked && !this.isPortalAdmin) {
            await this.usersStore.addRoleAsync(this.props.user, {
                role: 'PortalAdmin',
            });
        } else if (!target.checked && this.isPortalAdmin) {
            await this.usersStore.removeRoleAsync(this.props.user, 'PortalAdmin');
        }
    }

    @bind
    private async onMriAdminChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        if (!this.props.user) return;

        if (target.checked && !this.isMriAdmin) {
            await this.usersStore.addRoleAsync(this.props.user, {
                role: 'MriAdmin',
            });
        } else if (!target.checked && this.isMriAdmin) {
            await this.usersStore.removeRoleAsync(this.props.user, 'MriAdmin');
        }
    }

    @bind
    private async onMriUserChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        if (!this.props.user) return;

        if (target.checked && !this.isMriUser) {
            await this.usersStore.addRoleAsync(this.props.user, {
                role: 'MriUser',
            });
        } else if (!target.checked && this.isMriUser) {
            await this.usersStore.removeRoleAsync(this.props.user, 'MriUser');
        }
    }

    @bind
    private async onProdTestUserChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        if (!this.props.user) return;

        if (target.checked && !this.isProdTestUser) {
            await this.usersStore.addRoleAsync(this.props.user, {
                role: 'ProdTestUser',
            });
        } else if (!target.checked && this.isProdTestUser) {
            await this.usersStore.removeRoleAsync(this.props.user, 'ProdTestUser');
        }
    }

    @bind
    private async onProdUserChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        if (!this.props.user) return;

        if (target.checked && !this.isProdUser) {
            await this.usersStore.addRoleAsync(this.props.user, {
                role: 'ProdUser',
            });
        } else if (!target.checked && this.isProdUser) {
            await this.usersStore.removeRoleAsync(this.props.user, 'ProdUser');
        }
    }

    @bind
    private async onPortalUserChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        if (!this.props.user) return;

        if (target.checked && !this.isPortalUser) {
            await this.usersStore.addRoleAsync(this.props.user, {
                role: 'PortalUser',
            });
        } else if (!target.checked && this.isPortalUser) {
            await this.usersStore.removeRoleAsync(this.props.user, 'PortalUser');
        }
    }

    @bind
    private async onPortalLiteUserChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        if (!this.props.user) return;

        if (target.checked && !this.isPortalLiteUser) {
            await this.usersStore.addRoleAsync(this.props.user, {
                role: 'PortalLiteUser',
            });
        } else if (!target.checked && this.isPortalLiteUser) {
            await this.usersStore.removeRoleAsync(this.props.user, 'PortalLiteUser');
        }
    }

    @bind
    private async onCustomerServiceAdminUserChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        if (!this.props.user) return;

        if (target.checked && !this.isCustomerServiceAdminUser) {
            await this.usersStore.addRoleAsync(this.props.user, {
                role: 'MriCustomerServiceAdmin',
            });
        } else if (!target.checked && this.isCustomerServiceAdminUser) {
            await this.usersStore.removeRoleAsync(this.props.user, 'MriCustomerServiceAdmin');
        }
    }

    @bind
    private async onCustomerServiceRepUserChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        if (!this.props.user) return;

        if (target.checked && !this.isCustomerServiceRepUser) {
            await this.usersStore.addRoleAsync(this.props.user, {
                role: 'MriCustomerServiceRep',
            });
        } else if (!target.checked && this.isCustomerServiceRepUser) {
            await this.usersStore.removeRoleAsync(this.props.user, 'MriCustomerServiceRep');
        }
    }

    @computed
    private get isPortalAdmin() {
        if (this.props.user) return this.props.user.roles.includes('PortalAdmin');
        else return false;
    }

    @computed
    private get isMriAdmin() {
        if (this.props.user) return this.props.user.roles.includes('MriAdmin');
        else return false;
    }

    @computed
    private get isMriUser() {
        if (this.props.user) return this.props.user.roles.includes('MriUser');
        else return false;
    }

    @computed
    private get isProdTestUser() {
        if (this.props.user) return this.props.user.roles.includes('ProdTestUser');
        else return false;
    }

    @computed
    private get isProdUser() {
        if (this.props.user) return this.props.user.roles.includes('ProdUser');
        else return false;
    }

    @computed
    private get isPortalUser() {
        if (this.props.user) return this.props.user.roles.includes('PortalUser');
        else return false;
    }

    @computed
    private get isPortalLiteUser() {
        if (this.props.user) return this.props.user.roles.includes('PortalLiteUser');
        else return false;
    }

    @computed
    private get isCustomerServiceAdminUser() {
        if (this.props.user) return this.props.user.roles.includes('MriCustomerServiceAdmin');
        else return false;
    }

    @computed
    private get isCustomerServiceRepUser() {
        if (this.props.user) return this.props.user.roles.includes('MriCustomerServiceRep');
        else return false;
    }

    @inject
    private usersStore!: UsersStore;
    @inject
    private accountStore!: AccountStore;
}
